const Backdrop = () => {
    return (
        <img src={"backdrop.png"} alt="backdrop" id={"backdrop"}/>
    );
};

export default Backdrop;